import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../core/services/shared.service';

@Component({
  selector: 'app-error-page',
  imports: [],
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  errorMessage = '';

  private readonly route = inject(ActivatedRoute);
  private readonly sharedService = inject(SharedService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => {
        if (params['message']) {
          this.errorMessage = params['message'];
        }
      });

    const sharedErrorMessage = this.sharedService.getErrorMessage();
    if (sharedErrorMessage?.message) {
      this.errorMessage = sharedErrorMessage.message;
    }
  }
}
